import { columns } from "../../../../dtos/columns";
import AccionesPac from "../components/accionesPac";
import { AdministrarPacEdit, RespuestaPacDTO } from "../models/administrarPac";
import { format } from "rut.js";
import AdministradorPac from "../page/administradorPac";



interface IProps {
    controlTabla: any;
    setPacEditar: React.Dispatch<React.SetStateAction<AdministrarPacEdit | undefined>>;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
    isEdit: (value: boolean) => void;

}

export function useColumns({ controlTabla, setPacEditar, setModalDetalle, isEdit }: IProps) {

    const COLUMNS: columns<RespuestaPacDTO>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesPac
                    pac={row}
                    control={controlTabla}
                    setPacEditar={setPacEditar}
                    setModalDetalle={setModalDetalle}
                    isEdit={isEdit}

                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'N° operación',
            selector: (row) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'RUT deudor',
            selector: (row) =>
                format(row.rutDeudor),
            sortable: true,
            sortField: 'rutDeudor',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre deudor',
            selector: (row) => [row.nombresDeudor, row.apellidoPaternoDeudor, row.apellidoMaternoDeudor].filter(Boolean).join(' '),
            sortable: true,
            sortField: 'nombresDeudor',
            wrap: true,
            export: true
        },
        {
            name: 'Llave PAC',
            selector: (row) => row.llavePac,
            sortable: true,
            sortField: 'llavePac',
            wrap: true,
            export: true
        },
        {
            name: 'Estado PAC',
            selector: (row) => row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true
        },
    ];

    return { COLUMNS };
}